import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.post("/statistics/Statistics/index",{...params
    } )
}
function INDEX_AJAX(params){
    return  axios.post("/statistics/Statistics/indexAjax",{...params
    }  )
}
function EXPORT(params) {
    return  axios.post("/statistics/Statistics/export",{...params
    }  )
}
function GET_INDUSTRY_LIST(params) {
    return  axios.get("/customer/ACustomer/getIndustryList",{
        params: {
            ...params
        }
    }  )
}
export default {
    GET_LIST,
    EXPORT,
    INDEX_AJAX,GET_INDUSTRY_LIST
};
